"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ContentItem = _interopRequireDefault(require("../../shared/components/cms/ContentItem"));

var _ActionRoot = require("../../higher-order/ActionRoot");

var _constants = require("../../util/constants");

var _class, _class2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var Flash = (_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(Flash, _React$Component);

  var _super = _createSuper(Flash);

  function Flash() {
    _classCallCheck(this, Flash);

    return _super.apply(this, arguments);
  }

  _createClass(Flash, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var self = this;

      if (this.props.timeout && this.props.timeout > 0) {
        setTimeout(function () {
          self.handleCloseButton();
        }, this.props.timeout);
      }
    }
  }, {
    key: "handleCloseButton",
    value: function handleCloseButton(e) {
      if (e) {
        e.preventDefault();
      }

      this.context.dispatcher.emit("HIDE_FLASH_MESSAGE", {
        messageId: this.props.id,
        containerId: this.props.containerId
      });
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(e) {
      if (e.keyCode === _constants.KEYCODES.ENTER) {
        e.preventDefault();
        this.props.link.onClick();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("flash-message", this.props.className)
      }, this.props.closeable && /*#__PURE__*/_react.default.createElement("button", {
        className: "close-button",
        title: "Close",
        onClick: this.handleCloseButton
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-cancel-circled"
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: "message"
      }, Boolean(this.props.icon) && /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-" + this.props.icon
      }), this.props.contentKey ? /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "span",
        contentKey: this.props.contentKey
      }) : this.props.message, Boolean(this.props.link) && /*#__PURE__*/_react.default.createElement("a", {
        onClick: this.props.link.onClick,
        onKeyUp: this.handleKeyUp,
        role: "button",
        tabIndex: 0
      }, this.props.link.label)));
    }
  }]);

  return Flash;
}(_react.default.Component), _defineProperty(_class2, "contextType", _ActionRoot.ActionRootContext), _defineProperty(_class2, "propTypes", {
  id: _propTypes.default.string,
  message: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  contentKey: _propTypes.default.string,
  timeout: _propTypes.default.number,
  className: _propTypes.default.string,
  closeable: _propTypes.default.bool,
  icon: _propTypes.default.string,
  link: _propTypes.default.shape({
    label: _propTypes.default.string,
    href: _propTypes.default.string
  }),
  containerId: _propTypes.default.string
}), _defineProperty(_class2, "defaultProps", {
  id: Math.floor(new Date().getTime()),
  className: "success",
  closeable: true
}), _class2), (_applyDecoratedDescriptor(_class.prototype, "handleCloseButton", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleCloseButton"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeyUp", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyUp"), _class.prototype)), _class);
var _default = Flash;
exports.default = _default;